/* global module, require */
const crel = require('./createElement');

module.exports = function createDocument(_parent, elements) {
	return elements.map(spec => {
		// it's a bare string!
		if (typeof spec === 'string') return crel({ _parent, innerText: spec });

		// it's a DOM element!
		if (spec.nodeType > 0) {
			if (spec.parentElement) spec.parentElement.remove(spec);
			if (_parent) _parent.appendChild(spec);
			return spec;
		}

		const { _children, ...base } = spec;
		const el = crel({ ...base, _parent });

		if (_children) createDocument(el, _children);

		return el;
	});
};
